/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import {
  useState,
  useRef,
  useEffect,
  createContext,
  useContext,
  useMemo,
  Fragment as _,
  cloneElement,
  useCallback,
  RefObject,
} from 'react';

export const InputText = ({
  width,
  height,
  placeholder = '',
  focusColor = '#000',
  callback = (value: String) => {},
}) => {
  // const {
  //   width,
  //   focusColor = '#000',
  //   callback = (value: String) => {},
  // } = props;

  const [value, setValue] = useState('');
  const [hasFocus, setHasFocus] = useState(false);

  useEffect(() => {
    callback(value);
  }, [value]);

  return (
    <div
      css={css({
        position: 'relative',
        width,
        height,
        // outline: `50px solid #ff0000`,
      })}
    >
      {!hasFocus && (
        <div
          className="data-input-blur-value-display"
          css={css({
            position: 'absolute',
            width,
            // whiteSpace: 'nowrap',

            overflow: 'hidden',

            // for textarea
            height: '100%',
          })}
        >
          {value}
        </div>
      )}

      {/* <input
        type="text"
        css={css({
          all: 'unset',
          position: 'relative',
          width,
          opacity: !value || hasFocus ? 1 : 0,
          ':focus': {
            all: 'unset',
            width,
            outline: `1px solid ${focusColor}`,
            // boxShadow: `0 0 0 1px ${focusColor}`,
            border: 'transparent !important',
            overflow: 'visible',
          },
        })}
        placeholder={placeholder}
        onFocus={() => {
          setHasFocus(true);
        }}
        onBlur={() => {
          setHasFocus(false);
        }}
        onChange={e => {
          setValue(e.currentTarget.value);
        }}
      /> */}

      <textarea
        css={css({
          all: 'unset',
          position: 'relative',
          width,
          opacity: !value || hasFocus ? 1 : 0,

          height: '100%',
          // outline: `1px solid #ff0000`,

          overflow: 'hidden',
          resize: 'none',

          whiteSpace: 'pre-wrap',

          ':focus': {
            all: 'unset',
            width,
            height: '100%',
            outline: `1px solid ${focusColor}`,
            // boxShadow: `0 0 0 1px ${focusColor}`,
            border: 'transparent !important',
            // overflow: 'visible',

            overflow: 'hidden',
            resize: 'none',
          },
        })}
        placeholder={placeholder}
        onFocus={() => {
          setHasFocus(true);
        }}
        onBlur={() => {
          setHasFocus(false);
        }}
        onChange={e => {
          setValue(e.currentTarget.value);
        }}
        autoComplete="off"
      />
    </div>
  );
};
